import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LoginPage } from './login';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    LoginPage,
  ],
  imports: [
    IonicPageModule.forChild(LoginPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class LoginPageModule {}



// WEBPACK FOOTER //
// ./src/pages/login/login.module.ts